import React from 'react';
import { Helmet } from 'react-helmet';
import { seoContentData } from './seoContentData';

const BASE_URL = 'https://pdflove.mantham.com';
const SITE_NAME = 'PDFLove - Free Online PDF Tools & Converter';
const OG_IMAGE = `${BASE_URL}/logo512.png`;

const seoData = {
  home: {
    en: { title: 'PDFLove - Free Online PDF Tools & Converter', description: 'Convert, edit, merge, split and manage PDF files online for free. 20+ PDF tools — PDF to Word, Excel, JPG, PNG, PPT and more. No registration required.', keywords: 'PDF tools, PDF converter, free PDF tools, online PDF converter, merge PDF, split PDF, edit PDF, PDF to Word, PDF to Excel, PDF to JPG, PDF to PNG' },
    fr: { title: 'PDFLove - Outils PDF Gratuits en Ligne et Convertisseur', description: 'Convertissez, modifiez, fusionnez, divisez et gérez des fichiers PDF en ligne gratuitement. Plus de 20 outils PDF. Aucune inscription requise.', keywords: 'outils PDF, convertisseur PDF, outils PDF gratuits, convertisseur PDF en ligne, fusionner PDF, diviser PDF, modifier PDF' },
  },
  pdfConverter: {
    en: { title: 'PDF Converter - Convert Files to PDF Online Free', description: 'Free online PDF converter. Convert images (JPG, PNG) and text files (CSV, TXT, JSON, XML) to PDF instantly in your browser. No upload to servers.', keywords: 'PDF converter, convert to PDF, image to PDF, file to PDF, free PDF converter, online PDF converter' },
    fr: { title: 'Convertisseur PDF - Convertir des Fichiers en PDF en Ligne', description: 'Convertisseur PDF en ligne gratuit. Convertissez images et fichiers texte en PDF instantanément dans votre navigateur.', keywords: 'convertisseur PDF, convertir en PDF, image en PDF, convertisseur PDF gratuit' },
  },
  pdfToPng: {
    en: { title: 'PDF to PNG Converter - Convert PDF Pages to PNG Images Free', description: 'Convert PDF pages to high-quality PNG images online for free. Download individual pages or all pages as ZIP. No registration required.', keywords: 'PDF to PNG, convert PDF to PNG, PDF to image, PDF page to PNG, free PDF to PNG converter' },
    fr: { title: 'Convertisseur PDF en PNG - Convertir PDF en Images PNG Gratuit', description: 'Convertissez les pages PDF en images PNG de haute qualité en ligne gratuitement.', keywords: 'PDF en PNG, convertir PDF en PNG, PDF en image, convertisseur PDF en PNG gratuit' },
  },
  imageToPdf: {
    en: { title: 'Image to PDF Converter - Convert JPG, PNG to PDF Online Free', description: 'Convert images (JPG, PNG) to PDF format online for free. Combine multiple images into a single PDF. No file size limits.', keywords: 'image to PDF, JPG to PDF, PNG to PDF, convert image to PDF, photo to PDF, free image to PDF converter' },
    fr: { title: 'Convertisseur Image en PDF - Convertir JPG, PNG en PDF Gratuit', description: 'Convertissez des images au format PDF en ligne gratuitement. Combinez plusieurs images en un seul PDF.', keywords: 'image en PDF, JPG en PDF, PNG en PDF, convertir image en PDF, photo en PDF' },
  },
  pdfToWord: {
    en: { title: 'PDF to Word Converter - Convert PDF to DOCX Online Free', description: 'Convert PDF files to editable Word (DOCX) documents online for free. Preserve formatting and text quality. No software installation needed.', keywords: 'PDF to Word, convert PDF to Word, PDF to DOCX, PDF to Word converter, free PDF to Word' },
    fr: { title: 'Convertisseur PDF en Word - Convertir PDF en DOCX Gratuit', description: 'Convertissez des fichiers PDF en documents Word (DOCX) modifiables en ligne gratuitement.', keywords: 'PDF en Word, convertir PDF en Word, PDF en DOCX, convertisseur PDF en Word gratuit' },
  },
  pdfToExcel: {
    en: { title: 'PDF to Excel Converter - Extract PDF Tables to XLSX Free', description: 'Convert PDF tables to editable Excel (XLSX) spreadsheets online for free. Accurate data extraction from PDF tables.', keywords: 'PDF to Excel, convert PDF to Excel, PDF to XLSX, extract PDF tables, PDF to spreadsheet' },
    fr: { title: 'Convertisseur PDF en Excel - Extraire Tableaux PDF en XLSX', description: 'Convertissez des tableaux PDF en feuilles de calcul Excel (XLSX) modifiables en ligne gratuitement.', keywords: 'PDF en Excel, convertir PDF en Excel, PDF en XLSX, extraire tableaux PDF' },
  },
  mergePDF: {
    en: { title: 'Merge PDF - Combine PDF Files Online Free', description: 'Merge multiple PDF files into one document online for free. Easy drag-and-drop interface. No file count limits.', keywords: 'merge PDF, combine PDF, join PDF files, PDF merger, merge PDF online free' },
    fr: { title: 'Fusionner PDF - Combiner des Fichiers PDF en Ligne Gratuit', description: 'Fusionnez plusieurs fichiers PDF en un seul document en ligne gratuitement.', keywords: 'fusionner PDF, combiner PDF, joindre PDF, fusionneur PDF gratuit' },
  },
  splitPDF: {
    en: { title: 'Split PDF - Divide PDF into Separate Pages Free', description: 'Split PDF files into individual pages online for free. Extract specific pages from large PDF documents easily.', keywords: 'split PDF, divide PDF, extract PDF pages, PDF splitter, split PDF online free' },
    fr: { title: 'Diviser PDF - Séparer un PDF en Pages Individuelles Gratuit', description: 'Divisez des fichiers PDF en pages individuelles en ligne gratuitement.', keywords: 'diviser PDF, séparer PDF, extraire pages PDF, diviseur PDF gratuit' },
  },
  pdfToGif: {
    en: { title: 'PDF to GIF Converter - Convert PDF to Animated GIF Free', description: 'Convert PDF pages to animated GIF format online for free. Perfect for presentations and social media sharing.', keywords: 'PDF to GIF, convert PDF to GIF, PDF to animated GIF, PDF to GIF converter' },
    fr: { title: 'Convertisseur PDF en GIF - Convertir PDF en GIF Animé Gratuit', description: 'Convertissez les pages PDF au format GIF animé en ligne gratuitement.', keywords: 'PDF en GIF, convertir PDF en GIF, PDF en GIF animé' },
  },
  pdfToCsv: {
    en: { title: 'PDF to CSV Converter - Extract PDF Data to CSV Free', description: 'Extract tabular data from PDF files and convert to CSV format online for free. Compatible with Excel and databases.', keywords: 'PDF to CSV, convert PDF to CSV, extract PDF data, PDF table to CSV' },
    fr: { title: 'Convertisseur PDF en CSV - Extraire Données PDF en CSV Gratuit', description: 'Extrayez les données tabulaires des fichiers PDF et convertissez au format CSV en ligne gratuitement.', keywords: 'PDF en CSV, convertir PDF en CSV, extraire données PDF' },
  },
  pdfToJson: {
    en: { title: 'PDF to JSON Converter - Convert PDF to JSON Format Free', description: 'Convert PDF content to structured JSON format online for free. Ideal for developers and data processing workflows.', keywords: 'PDF to JSON, convert PDF to JSON, PDF data extraction, PDF to JSON converter' },
    fr: { title: 'Convertisseur PDF en JSON - Convertir PDF en JSON Gratuit', description: 'Convertissez le contenu PDF au format JSON structuré en ligne gratuitement.', keywords: 'PDF en JSON, convertir PDF en JSON, extraction données PDF' },
  },
  pdfToPpt: {
    en: { title: 'PDF to PPT Converter - Convert PDF to PowerPoint Free', description: 'Convert PDF files to PowerPoint (PPT) presentations online for free. Each PDF page becomes an editable slide.', keywords: 'PDF to PPT, convert PDF to PowerPoint, PDF to presentation, PDF to PPT converter' },
    fr: { title: 'Convertisseur PDF en PPT - Convertir PDF en PowerPoint Gratuit', description: 'Convertissez des fichiers PDF en présentations PowerPoint (PPT) en ligne gratuitement.', keywords: 'PDF en PPT, convertir PDF en PowerPoint, PDF en présentation' },
  },
  pdfToRtf: {
    en: { title: 'PDF to RTF Converter - Convert PDF to Rich Text Free', description: 'Convert PDF files to Rich Text Format (RTF) online for free. Compatible with all major word processors.', keywords: 'PDF to RTF, convert PDF to RTF, PDF to Rich Text, PDF to RTF converter' },
    fr: { title: 'Convertisseur PDF en RTF - Convertir PDF en Texte Enrichi Gratuit', description: 'Convertissez des fichiers PDF au format RTF en ligne gratuitement.', keywords: 'PDF en RTF, convertir PDF en RTF, PDF en texte enrichi' },
  },
  pdfToPptx: {
    en: { title: 'PDF to PPTX Converter - Convert PDF to PowerPoint PPTX Free', description: 'Convert PDF files to modern PPTX PowerPoint format online for free. Compatible with PowerPoint 2007+ and Google Slides.', keywords: 'PDF to PPTX, convert PDF to PPTX, PDF to PowerPoint, PDF to PPTX converter' },
    fr: { title: 'Convertisseur PDF en PPTX - Convertir PDF en PPTX Gratuit', description: 'Convertissez des fichiers PDF au format PowerPoint PPTX moderne en ligne gratuitement.', keywords: 'PDF en PPTX, convertir PDF en PPTX, PDF en PowerPoint PPTX' },
  },
  pdfToTxt: {
    en: { title: 'PDF to TXT Converter - Extract Text from PDF Free', description: 'Extract plain text from PDF documents online for free. Clean text output ideal for text analysis and data processing.', keywords: 'PDF to TXT, extract text from PDF, PDF to text, PDF text extractor' },
    fr: { title: 'Convertisseur PDF en TXT - Extraire le Texte d\'un PDF Gratuit', description: 'Extrayez le texte brut des documents PDF en ligne gratuitement.', keywords: 'PDF en TXT, extraire texte PDF, PDF en texte, extracteur texte PDF' },
  },
  pdfToDocx: {
    en: { title: 'PDF to DOCX Converter - Convert PDF to Word DOCX Free', description: 'Convert PDF files to modern DOCX Word format online for free. Compatible with Word 2007+, Google Docs, and LibreOffice.', keywords: 'PDF to DOCX, convert PDF to DOCX, PDF to Word, PDF to DOCX converter' },
    fr: { title: 'Convertisseur PDF en DOCX - Convertir PDF en Word DOCX Gratuit', description: 'Convertissez des fichiers PDF au format Word DOCX moderne en ligne gratuitement.', keywords: 'PDF en DOCX, convertir PDF en DOCX, PDF en Word DOCX' },
  },
  compareText: {
    en: { title: 'Compare Text Online - Find Differences Between Texts Free', description: 'Compare two texts side by side and find differences instantly. Free online text comparison tool with color-coded highlighting.', keywords: 'compare text, text comparison, text diff, find text differences, compare files online' },
    fr: { title: 'Comparer du Texte en Ligne - Trouver les Différences Gratuit', description: 'Comparez deux textes côte à côte et trouvez les différences instantanément.', keywords: 'comparer texte, comparaison texte, diff texte, trouver différences texte' },
  },
  jsonEditor: {
    en: { title: 'JSON Editor Online - View, Edit, Format & Validate JSON Free', description: 'Free online JSON editor. View, edit, format, beautify, minify, and validate JSON data. Convert JSON to CSV, XML, and YAML.', keywords: 'JSON editor, JSON viewer, JSON formatter, JSON validator, edit JSON online, JSON beautifier' },
    fr: { title: 'Éditeur JSON en Ligne - Visualiser, Modifier et Formater JSON Gratuit', description: 'Éditeur JSON en ligne gratuit. Visualisez, modifiez, formatez et validez vos données JSON.', keywords: 'éditeur JSON, visualiseur JSON, formateur JSON, validateur JSON, modifier JSON en ligne' },
  },
  editPdfMetadata: {
    en: { title: 'Edit PDF Metadata - Change PDF Properties Online Free', description: 'Edit PDF metadata online for free. Change title, author, subject, and keywords of your PDF files.', keywords: 'edit PDF metadata, change PDF properties, PDF metadata editor, PDF info editor' },
    fr: { title: 'Modifier Métadonnées PDF - Changer Propriétés PDF Gratuit', description: 'Modifiez les métadonnées PDF en ligne gratuitement. Changez le titre, l\'auteur et le sujet.', keywords: 'modifier métadonnées PDF, changer propriétés PDF, éditeur métadonnées PDF' },
  },
  annotatePdf: {
    en: { title: 'Annotate PDF Online - Add Notes & Comments to PDF Free', description: 'Annotate PDF files online for free. Add text annotations, notes and comments to any page of your PDF document.', keywords: 'annotate PDF, PDF annotator, add notes to PDF, PDF comments, PDF markup tool' },
    fr: { title: 'Annoter un PDF en Ligne - Ajouter Notes et Commentaires Gratuit', description: 'Annotez vos fichiers PDF en ligne gratuitement. Ajoutez des annotations textuelles à vos documents PDF.', keywords: 'annoter PDF, annotateur PDF, ajouter notes PDF, commentaires PDF' },
  },
  pdfEditor: {
    en: { title: 'PDF Editor Online - Edit PDF Files Free', description: 'Free online PDF editor. Add text, images, shapes, and annotations to your PDF documents. Fill and sign PDF forms. No download required.', keywords: 'PDF editor, edit PDF, free PDF editor, online PDF editor, modify PDF, fill PDF forms' },
    fr: { title: 'Éditeur PDF en Ligne - Modifier des Fichiers PDF Gratuit', description: 'Éditeur PDF en ligne gratuit. Ajoutez du texte, images, formes et annotations à vos documents PDF.', keywords: 'éditeur PDF, modifier PDF, éditeur PDF gratuit, éditeur PDF en ligne' },
  },
};

const SEO = ({
  title,
  description,
  keywords,
  lang = 'en',
  url = '',
  type = 'website',
  pageType = 'home'
}) => {
  const data = seoData[pageType]?.[lang] || seoData[pageType]?.en || seoData.home.en;
  const finalTitle = title || data.title;
  const finalDescription = description || data.description;
  const finalKeywords = keywords || data.keywords;
  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL;
  const enUrl = url.startsWith('/fr') ? url.substring(3) || '/' : url;

  // Build breadcrumbs
  const breadcrumbs = [{ name: 'Home', url: BASE_URL }];
  if (pageType !== 'home') {
    breadcrumbs.push({ name: finalTitle.split(' - ')[0].split(' | ')[0], url: fullUrl });
  }

  // Build FAQ schema from content data
  const contentData = seoContentData[pageType]?.[lang] || seoContentData[pageType]?.en;
  const faqItems = contentData?.faq || [];
  const howToSteps = contentData?.howTo || [];

  const schemas = [];

  // WebApplication schema
  schemas.push({
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": finalTitle,
    "description": finalDescription,
    "url": fullUrl,
    "applicationCategory": "UtilityApplication",
    "operatingSystem": "Web Browser",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    "author": { "@type": "Organization", "name": "PDFLove", "url": BASE_URL }
  });

  // BreadcrumbList schema
  schemas.push({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.name,
      "item": item.url
    }))
  });

  // FAQ schema
  if (faqItems.length > 0) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqItems.map(item => ({
        "@type": "Question",
        "name": item.q,
        "acceptedAnswer": { "@type": "Answer", "text": item.a }
      }))
    });
  }

  // HowTo schema
  if (howToSteps.length > 0 && pageType !== 'home') {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "HowTo",
      "name": finalTitle,
      "description": finalDescription,
      "step": howToSteps.map((step, i) => ({
        "@type": "HowToStep",
        "position": i + 1,
        "name": step.title,
        "text": step.description
      }))
    });
  }

  return (
    <Helmet>
      <html lang={lang} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="author" content="PDFLove" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content={lang} />

      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={lang === 'fr' ? 'fr_FR' : 'en_US'} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={OG_IMAGE} />

      <link rel="canonical" href={fullUrl} />
      <link rel="alternate" hrefLang="en" href={`${BASE_URL}${enUrl}`} />
      <link rel="alternate" hrefLang="fr" href={`${BASE_URL}/fr${enUrl === '/' ? '' : enUrl}`} />
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}${enUrl}`} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;